import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "guides"
    }}>{`Guides`}</h1>
    <p>{`A collections class allowing for array access into a document's guides`}</p>
    <p>{`Access this collection through `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/document/#guides"
      }}>{`Document.guides`}</a>{` property. For example,
following adds a new guide to the collection:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`app.activeDocument.guides.add(Constants.Direction.HORIZONTAL, 20);
`}</code></pre>
    <h2 {...{
      "id": "indexable"
    }}>{`Indexable`}</h2>
    <p>{`▪ `}{`[index: `}<em parentName="p">{`number`}</em>{`]`}{`: `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/guide/"
      }}><em parentName="a">{`Guide`}</em></a></p>
    <p>{`Used to access the guides in the collection`}</p>
    <p>{`Access this collection through `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/document/#guides"
      }}>{`Document.guides`}</a>{` property. For example,
following adds a new guide to the collection:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`app.activeDocument.guides.add(Constants.Direction.HORIZONTAL, 20);
`}</code></pre>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Access`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`length`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Number of `}<a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/guide/"
            }}>{`Guide`}</a>{` elements in this collection`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`parent`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Document`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The owner document of this Guide collection`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "methods"
    }}>{`Methods`}</h2>
    <h3 {...{
      "id": "add"
    }}>{`add`}</h3>
    <p><em parentName="p">{`void`}</em></p>
    <p>{`Adds a guide for the collection at the given coordinate and direction`}</p>
    <h4 {...{
      "id": "parameters"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`direction`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#direction"
            }}><em parentName="a">{`Direction`}</em></a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`coordinate`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "removeall"
    }}>{`removeAll`}</h3>
    <p><em parentName="p">{`void`}</em></p>
    <p>{`Clears all guides from this collection`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      